module.exports = __webpack_public_path__ + "assets/media/eye.c1259b93.svg";